import { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const FAQ = () => {
    const [openIndex, setOpenIndex] = useState(null);

    const faqs = [
        {
            question: "How long does shipping take?",
            answer: "Shipping typically takes 3-5 business days for standard delivery within the country. International shipping can take 7-14 days depending on the location."
        },
        {
            question: "What is your return policy?",
            answer: "We accept returns within 30 days of purchase. Items must be unused, in their original packaging, and with all tags attached. Please visit our Returns page to initiate a return."
        },
        {
            question: "Can I cancel my order?",
            answer: "You can cancel your order within 1 hour of placing it. After that, we may have already processed it. Please contact support immediately if you need to cancel."
        },
        {
            question: "How do I track my order?",
            answer: "You can track your order in the 'My Orders' section of your account. We also send email updates with tracking numbers once your package ships."
        },
        {
            question: "Do you offer international shipping?",
            answer: "Yes, we ship to select international countries. Shipping costs and times vary by location."
        }
    ];

    return (
        <div className="max-w-3xl mx-auto py-12 md:py-20 px-6">
            <h1 className="text-3xl md:text-4xl font-bold mb-4 text-center">Frequently Asked Questions</h1>
            <p className="text-zinc-500 text-center mb-16">Everything you need to know about our services.</p>

            <div className="space-y-4">
                {faqs.map((faq, index) => (
                    <div key={index} className="border border-zinc-200 rounded-2xl bg-white overflow-hidden transition-all">
                        <button
                            onClick={() => setOpenIndex(openIndex === index ? null : index)}
                            className="w-full flex items-center justify-between p-6 text-left font-bold text-lg text-zinc-900 hover:bg-zinc-50"
                        >
                            {faq.question}
                            {openIndex === index ? <Minus size={20} /> : <Plus size={20} />}
                        </button>

                        <div
                            className={`px-6 text-zinc-600 leading-relaxed overflow-hidden transition-all duration-300
                                ${openIndex === index ? 'max-h-48 pb-6 opacity-100' : 'max-h-0 opacity-0'}
                            `}
                        >
                            {faq.answer}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FAQ;
